import React from 'react';
import { observer } from 'mobx-react';
import CharacterVoiceSearchDialog from './CharacterVoiceSearchDialog';
import CharacterVoiceSearchService from '../services/CharacterVoiceSearchService';
import { toJS } from 'mobx';

const CharacterVoiceSearchDialogContainer = (props) => (
  <CharacterVoiceSearchDialog
    voices={toJS(CharacterVoiceSearchService.voices)}
    isOpen={toJS(CharacterVoiceSearchService.isVoiceSearchModalOpen)}
    onClose={CharacterVoiceSearchService.handleClose}
    onFilter={CharacterVoiceSearchService.handleLoad}
    fetching={CharacterVoiceSearchService.fetch.fetching}
    onSelect={props.onSelect}
    onChange={CharacterVoiceSearchService.form.setValue}
    values={toJS(CharacterVoiceSearchService.form.getValues())}
  />
);

export default observer(CharacterVoiceSearchDialogContainer);
